import moment from 'moment';
import firebase from 'firebase/app';
import 'firebase/auth';

export const LOGIN_USER_PENDING = 'LOGIN_USER_PENDING';
export const LOGIN_USER_FULFILLED = 'LOGIN_USER_FULFILLED';
export const LOGIN_USER_FAILED = 'LOGIN_USER_FAILED';

export const LOGOUT_USER_PENDING = 'LOGOUT_USER_PENDING';
export const LOGOUT_USER_FULFILLED = 'LOGOUT_USER_FULFILLED';
export const LOGOUT_USER_FAILED = 'LOGOUT_USER_FAILED';

// ACTION GENERATORS


const login = (email, password) => (dispatch) => {
    dispatch({
        type: LOGIN_USER_PENDING
    });

    return firebase.auth().signInWithEmailAndPassword(email, password).then((user) => {
        dispatch({
            type: LOGIN_USER_FULFILLED,
            payload: user
        });
    }).catch(error => {
        dispatch({
            type: LOGIN_USER_FAILED,
            payload: error,
        });
    });
};

const logout = (email, password) => (dispatch) => {
    dispatch({
        type: LOGOUT_USER_PENDING
    });

    return firebase.auth().signOut().then(() => {
        dispatch({
            type: LOGOUT_USER_FULFILLED,
        });
    }).catch(error => {
        dispatch({
            type: LOGOUT_USER_FAILED,
            payload: error,
        });
    });
};



// EXPORT ACTIONS

export { login, logout };